// extracted by mini-css-extract-plugin
export default {"discountBanner":"cba","topheader":"eba","navleft":"fba","navflexelem":"gba","navright":"hba","fixedtop":"iba","abstop":"jba","subdesc":"kba","smallscreennav":"lba","nav_hidden":"mba","cancel_link":"nba","bottomnavcontainer":"oba","fixedbottom":"pba","animatedbottom":"qba","appear-bottom":"rba","delayedbottom":"sba","retakebtn":"tba","long_banner":"uba","nofixed":"vba"};
    if(module.hot) {
      // 1715632479653
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  